const PATTERNS: { match: RegExp; key: string }[] = [
	{ match: /has no sapCardCode/i, key: "syncErrorNoCardCode" },
	{ match: /has no company assigned/i, key: "syncErrorNoCompany" },
	{ match: /has no lines/i, key: "syncErrorNoLines" },
	{ match: /no valid lines after filtering/i, key: "syncErrorNoValidLines" },
	{ match: /circuit breaker is open/i, key: "syncErrorSapUnreachable" },
	{ match: /SQL_AUTOCOMMIT|"code"\s*:\s*-1200\b/i, key: "syncErrorSapSession" },
	{ match: /Value too long in property/i, key: "syncErrorValueTooLong" },
	{ match: /Enter valid currency code/i, key: "syncErrorInvalidCurrency" },
	{ match: /Possible duplicate SAP order/i, key: "syncErrorPossibleDuplicate" },
	{ match: /SAP request failed(?: after relogin)?: 5\d\d\b/i, key: "syncErrorSapNoResponse" },
	{ match: /Inactive items in document|is inactive/i, key: "syncErrorInactiveItem" },
	{ match: /not configured/i, key: "syncErrorNotConfigured" },
];

export function syncErrorSummary(
	raw: string | null | undefined,
	t: (key: string) => string,
): string | undefined {
	if (!raw) return undefined;
	const hit = PATTERNS.find((p) => p.match.test(raw));
	return hit ? t(hit.key) : (sapMessage(raw) ?? raw);
}

// "SAP request failed: 400 { "error": { "message": { "value": "..." } } }" gövdesinden
// SAP'ın kendi mesajını çıkarır; ham JSON'u kullanıcıya göstermemek için.
function sapMessage(raw: string): string | undefined {
	const start = raw.indexOf("{");
	if (start < 0) return undefined;
	try {
		const body = JSON.parse(raw.slice(start)) as { error?: { message?: { value?: string } } };
		return body.error?.message?.value;
	} catch {
		return undefined;
	}
}

export function describeSyncError(
	raw: string | null | undefined,
	t: (key: string) => string,
): string | undefined {
	if (!raw) return undefined;
	const hit = PATTERNS.find((p) => p.match.test(raw));
	if (!hit) return raw;
	return `${t(hit.key)}\n\n${raw}`;
}
